module.exports = __webpack_public_path__ + "fonts/GTAmericaMono-Regular.5961f543.woff";